<template>
    <div class="land-news">
        <div class="container">
            <div class="land-section-title" v-if="salesCardPage != null">
                <h2>{{salesCardPage.land_site_section_titles.news}}</h2>
            </div>
            <div class="land-news-items">
                <div class="item" v-for="(item, index) in salesCard.project_land_site.news_items" :key="index">
                    <div class="item-title">
                        <h3>{{item.title}}</h3>
                    </div>
                    <div class="item-ready">
                        <div class="ready-scale">
                            <div class="default-line"></div>
                            <div class="ready-line" :style="'width:' + item.ready_number + '%'"></div>
                        </div>
                        <div class="item-ready-number" :style="'left:' + item.ready_number + '%'">
                            <h4>
                                {{item.ready_number}}
                                <!-- <animate-number 
                                    from="0" 
                                    :to="item.ready_number"
                                    duration="2000"  
                                    easing="easeOutQuad"
                                    :formatter="formatter"
                                ></animate-number> -->
                            </h4>
                            <span>%</span>
                        </div>
                    </div>
                    <a href="#" class="land-news-link" :disabled="item.btn_activity == false">Подробнее</a>
                </div>
            </div>
        </div>
    </div>   
</template>

<script>
    import {mapGetters} from 'vuex'
    // import PROMOpage from '@/components/sales/sales-promo-page.vue'
    export default {
        name: 'sale-land-news',
        components: {
        },
        data () {
            return {
                routerName: this.$router.history.current.name,
                cardID: this.$route.params.id,
            }
        },
        computed: mapGetters({
            salesCard: 'loadSalesCardContent',
            salesCardPage: 'loadSalesCardPage',
        }),
        methods: {
        },
        beforeCreate() {
        },
        created () {
        },
        mounted () {
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/sales/sales-land-partials/land-news.scss';
     @import '@/styles/respond/sales/sales-land-partials/land-news-respond.scss';
    // @import '@/styles/respond/sales/respond-sale-item.scss';
</style>